module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.083 22V10l-8 6 8 6zm0-6l8 6V10l-8 6z\"></path></svg>"